import Home from "@/pages/Home.vue";
import Services from "@/pages/Services.vue";
import Clientes from "@/pages/Clientes.vue";
import Nosotros from "@/pages/Nosotros.vue";
/* páginas de servicios */
import Coaching from "@/pages/services/Coaching.vue";
import Dominios from "@/pages/services/Redes.vue";
import Desarrollos from "@/pages/services/Desarrollos.vue";
import Soluciones from "@/pages/services/Soluciones.vue";
import Outsourcing from "@/pages/services/Outsourcing.vue";
import Facturacion from "@/pages/services/Facturacion.vue";

export const routes =  [
        {
            //redirecciono al home siempre que la ruta no exista
            path: "*",
            redirect: "/"
        },
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            //path: '/servicio/:ServiceDetail',
            path: '/servicios',
            name: 'Servicios',
            component: Services
        },
        /*lista de páginas estáticas de los servicios (por ahora, luego se pueden cargar de BD ) */
        {
            path: '/servicio/soluciones-web',
            name: 'Soluciones',
            component: Soluciones
        },
        {
            //path: '/servicio/:ServiceDetail',
            path: '/servicio/dominios-hosting',
            name: 'Dominios y hosting',
            component: Dominios
        },
        {
            //path: '/servicio/:ServiceDetail',
            path: '/servicio/desarrollos-de-aplicaciones',
            name: 'Desarrollos',
            component: Desarrollos
        },
        {
            //path: '/servicio/:ServiceDetail',
            path: '/servicio/optimizacion-de-procesos',
            name: 'Coaching',
            component: Coaching
        },
        {
            //path: '/servicio/:ServiceDetail',
            path: '/servicio/outsourcing',
            name: 'Outsourcing',
            component: Outsourcing
        },
        {
            //path: '/servicio/:ServiceDetail',
            path: '/servicio/facturacion',
            name: 'Facturacion',
            component: Facturacion
        },
        /*fin lista de páginas estáticas de los servicios (por ahora, luego se pueden cargar de BD ) */
        {
            //path: '/clientes',
            path: '/clientes',
            name: 'Clientes',
            component: Clientes
        },
        {
            //path: '/nosotros/',
            path: '/nosotros',
            name: 'Nosotros',
            component: Nosotros
        }         
    ];

  


// WEBPACK FOOTER //
// ./src/routes.js